export const Env = {
    ...{
        production: false,
        baseUrl: "https://development.wallet.blueride.app/api/",
    }, // any custom env config here
    // --------------------------------------------------------------------
    // base env config here (this imported as separate JS script in Angular.Json as separated script)
    ... (window as any).bootstrapConfigSettings
}